/**
 * Handles AJAX request easier.
 */
export default class Ajax {
	/**
	 * Initiates an AJAX request.
	 * @param  {object} args Class parameters
	 */
	constructor(args = {}) {
		this.method   = (args.method)   ? args.method   : 'POST';     // POST or GET
		this.ajaxURL  = (args._ajaxURL) ? args._ajaxURL : vb.ajaxURL; // ajaxURL is a global variable
		this.form     = (args.form)     ? args.form     : null;       // Form to be submitted
		this.params   = (args.params)   ? args.params   : null;       // Parameters to send
		this.callback = (args.callback) ? args.callback : null;       // Callback function
		
		this.createRequest();
		this.sendRequest();
	}

	/**
	 * Creates a XMLHttpRequest with provided data.
	 */
	createRequest() {
		this.data = this.form ? new FormData(this.form) : new FormData();
		this.query = '';
		this.request = new XMLHttpRequest();

		for (let key in this.params) {
			this.data.append(key, this.params[key]);
			this.query += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(this.params[key]);
		}

		this.query = this.query.substr(1);
	}

	/**
	 * Sends the request.
	 */
	sendRequest() {
		if (this.method === 'POST') {
			this.request.open('POST', this.ajaxURL);
			this.request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
			this.request.addEventListener('load', e => this.loaded(e));
			this.request.send(this.data);
		} else if (this.method == 'GET') {
			this.request.open('GET', `${this.ajaxURL}${this.query ? `?${this.query}` : ''}`);
			this.request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
			this.request.addEventListener('load', e => this.loaded(e));
			this.request.send();
		}
	}

	/**
	 * Triggers a callback method after server response.
	 * @param  {Object} e Event object
	 */
	loaded(e) {
		this.status = e.target.status;
		this.ok = (this.status >= 200 && this.status < 400);
		
		if (this.ok) {
			try {
				this.response = JSON.parse(e.target.response);
			} catch (error) {
				// console.error(`Could not parse AJAX response (${this.ajaxURL})`);
			}
		}
		
		if (this.callback) {
			this.callback.call(null, this);
		}
	}
}
